<template>
  <div>
    <button class="btn btn-outline-primary mr-4" @click="showStaticalDataModal">
      {{ $t('src/components/staticaldata.static') }}
    </button>

    <base-modal
      :is-show="isShowModal"
      class="filter-modal"
      mode="apply"
      @close="closeStaticalDataModal"
      @confirm="confirmSaveCloseDate"
    >
      <template #header>{{ $t('src/components/staticaldata.download') }}</template>
      <template #body>
        <div v-if="loading" style="text-align: center; padding-top: 20px; padding-bottom: 20px;">
          <base-spinner></base-spinner>
        </div>
        <template v-else>
          <div class="filter-group text-left">
            <label class="filter-label">{{ $t('general.startDate') }}</label>
            <base-reset-button v-if="localDates.startDate" @input="clearStartDate"></base-reset-button>
            <base-calendar-wrap>
              <date-input
                v-model="localDates.startDate"
                @input="$v.localDates.startDate.$touch()"
                :allow-input="true"
                :max-date="localDates.endDate"
                :placeholder="$t('src/components/staticaldata.selectStartDate')"
              ></date-input>
            </base-calendar-wrap>
          </div>
          <div class="filter-group text-left">
            <label class="filter-label">{{ $t('general.endDate') }}</label>
            <base-reset-button v-if="localDates.endDate" @input="clearEndDate"></base-reset-button>
            <base-calendar-wrap>
              <date-input
                v-model="localDates.endDate"
                @input="$v.localDates.endDate.$touch()"
                :allow-input="true"
                :min-date="localDates.startDate"
                :placeholder="$t('src/components/staticaldata.selectEndDate')"
              ></date-input>
            </base-calendar-wrap>
          </div>
        </template>
      </template>
    </base-modal>
  </div>
</template>

<script>
import http from '@/modules/http.js'
import { DATE_FORMAT } from '@/main.config.js'
import moment from 'moment/src/moment'

export default {
  name: 'StaticalData',
  components: {
    BaseModal: () => import('@/base/BaseModal.vue'),
    BaseCalendarWrap: () => import('@/base/BaseCalendarWrap'),
    BaseResetButton: () => import('@/base/BaseResetButton.vue'),
    BaseSpinner: () => import('@/base/BaseSpinner.vue'),
    DateInput: () => import('@/plugins/DateInput.vue')
  },
  data: () => ({
    loading: false,
    isShowModal: false,
    localDates: {
      startDate: null,
      endDate: null
    },
    now: new Date(),
    hospitalCreatedDate: null
  }),
  async mounted() {
    await this.setHospitalCreatedDate()
    this.setDefaultDates()
  },
  computed: {
    params() {
      const params = {
        hospital_id: this.$store.getters.AUTH_USER.hospital_id || this.$store.getters.SELECTED_HOSPITAL,
        locale: this.$i18n.locale
      }
      if (this.localDates.startDate && this.localDates.endDate) {
        params['start_date'] = moment(this.localDates.startDate).format(DATE_FORMAT.serverFull)
        params['end_date'] = moment(this.localDates.endDate).format(DATE_FORMAT.serverFull)
      }
      return params
    }
  },
  methods: {
    showStaticalDataModal() {
      this.isShowModal = true
    },
    closeStaticalDataModal() {
      this.isShowModal = false
    },
    confirmSaveCloseDate() {
      if (!this.loading) {
        this.loading = true
        http
          .get('/export_report', {
            headers: {
              Accept: 'application/octet-stream',
              'Cache-Control': 'no-cache'
            },
            responseType: 'blob',
            params: this.params
          })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            const now = new Date()
            const fileName = `trainings_report_${now.getTime()}.xlsx`
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
          .then(() => {
            this.loading = false
            this.closeStaticalDataModal()
            this.clearDates(null, null)
          })
      }
    },
    changeDates(start, end) {
      this.localDates.startDate = start
      this.localDates.endDate = end
    },
    clearStartDate() {
      this.localDates.startDate = this.moment(this.hospitalCreatedDate).format(DATE_FORMAT.serverFull)
    },
    clearEndDate() {
      this.localDates.endDate = this.moment(this.now).format(DATE_FORMAT.serverFull)
    },
    setDefaultDates() {
      this.localDates.startDate = this.moment(this.hospitalCreatedDate).format(DATE_FORMAT.serverFull)
      this.localDates.endDate = this.moment(this.now).format(DATE_FORMAT.serverFull)
    },
    async setHospitalCreatedDate() {
      const hospitalId = this.$store.getters.AUTH_USER.hospital_id || this.$store.getters.SELECTED_HOSPITAL
      await http.get('/hospitals/' + hospitalId).then(response => {
        this.hospitalCreatedDate = response.data.createdAt
      })
    }
  }
}
</script>
